module.exports = __webpack_public_path__ + "img/login_background.8f4e9c63.jpg";